import { EC } from "../utils/const/ecommerce-colors-const";

const CircularProgress = () => (
  <svg
    className="animate-spin h-5 w-5 text-current"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

const VARIANT_CLASSES = {
  primary:
    "bg-ct-primary-600 text-white hover:bg-ct-primary-700 shadow-lg shadow-ct-primary-600/25 disabled:hover:bg-ct-primary-600",
  secondary: "bg-white text-slate-800 border-2 border-slate-200 hover:border-ct-primary-400 hover:text-ct-primary-800",
  cancel: "bg-white text-slate-700 border-2 border-slate-200 hover:border-slate-300 hover:bg-slate-50",
};

export function FormSubmitButton({
  loading = false,
  onClick,
  label = "Aceptar",
  className = "",
  type = "button",
  variant = "primary",
  fullWidth = false,
  disabled = false,
}) {
  const variantClass = VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.primary;
  const isDisabled = loading || disabled;

  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 rounded-xl px-8 py-3.5 text-base font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed ${variantClass} ${fullWidth ? "w-full" : "min-w-[9rem] sm:min-w-[10rem]"} ${className}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {loading && <CircularProgress />}
      <span>{label}</span>
    </button>
  );
}

export function FormCancelButton({
  onClick,
  label = "Cancelar",
  className = "",
  disabled = false,
  type = "button",
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 min-w-[9rem] sm:min-w-[10rem] disabled:opacity-50 disabled:cursor-not-allowed ${EC.btn.secondary} ${className}`}
    >
      {label}
    </button>
  );
}

export function FormActionsBar({ children, className = "" }) {
  return (
    <div
      className={`flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-between gap-3 pt-6 mt-6 border-t border-slate-200 ${className}`}
    >
      {children}
    </div>
  );
}
